import { useUserStore } from "@/common/store";
import { useAgeVerificationStore } from "@/common/store/ageVerificationStore";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { isAgeVerificationLocation } from "@/common/utils/geoRules";
import { useEffect } from "react";
import { apiVerification } from "@/common/api";
import { useAgeVerificationToken } from "@/components/app/AppHooks/hooks/useAgeVerificationToken";

export const useAgeVerification = () => {
  const geoLocation = useGeolocationStore((state) => state.location);
  const currentUser = useUserStore((state) => state.currentUser);
  const setAgeVerified = useAgeVerificationStore((state) => state.setAgeVerified);
  const { token } = useAgeVerificationToken();

  useEffect(() => {
    const resolveAgeVerification = async () => {
      if (currentUser === undefined || geoLocation === null || token === undefined) {
        return;
      }

      const inAgeVerificationLocation = isAgeVerificationLocation(geoLocation);
      const isAgeVerified = Boolean(currentUser?.ageVerified) && inAgeVerificationLocation;
      const isUserVerified = Boolean(currentUser?.verified);

      if (isUserVerified || isAgeVerified) {
        setAgeVerified(true);
        return;
      }

      if (!inAgeVerificationLocation || token === null) {
        setAgeVerified(false);
        return;
      }

      try {
        await apiVerification.verifyAgeWithToken(token);
        setAgeVerified(true);
      } catch {
        setAgeVerified(false);
        return;
      }

      if (currentUser !== null && !currentUser.ageVerified) {
        try {
          apiVerification.linkToken(token);
        } catch (e) {
          console.warn("Failed to link token with account", e);
        }
      }
    };

    resolveAgeVerification();
  }, [currentUser, geoLocation, token]);
};
